import {
  IApiFilter,
  IKeyValue,
  IRouteConfig,
  IToggleContent,
  IAutoRefresh
} from '@fareye/types'
import React, { ReactElement, ReactNode } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import json2csv from 'json2csv'

export interface WithTranslation {
  t: any
  i18n: any
}

export interface ITripTableProps extends RouteComponentProps {
  data: any
  size?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl'
  plant?: any
  refreshableTable?: boolean
  baseUrl?: string
  timer?: number
  selectedColumn?: any
  fileName: string
  searchData: string
  subFilter?: any[]
  mapping?: { [key: string]: ReactNode | ReactElement }
  style?: React.CSSProperties
  isRealTimeAlertApi?: boolean
  setLastUpdate?: any
  startDate?: string
  endDate?: string
  config: any // IPageConfig
  columns: string[]
  selectedKey: string
  searchQuery?: any
  issueResourceId?: string
  setSummaryFilter?: (s: any) => void
  setSummaryData?: (s: any) => void
}

type FilterTypes = 'apiFilter'
type IFilter = { readonly [f in FilterTypes]: IApiFilter | any }
export interface IFilterDataFormat {
  readonly label: string
  readonly value: string
}

export interface IFilterOptions extends Partial<IFilter> {
  apiFilter?: any
  filterData?: { [key: string]: IFilterDataFormat[] }
  selectedFilters?: IKeyValue<string | Date | {}>
}

export interface IGraphCard {
  heading: ReactNode | JSX.Element | string
  children: ReactNode | JSX.Element | string
  graphId?: string
}

export interface ISearchES {
  apiFav: IApiFilter
  pageId: string
  search: IKeyValue<string | number>[]
  endDate: Date | string | undefined
  startDate: Date | string | undefined
  apiFilter: IApiFilter
  children?: JSX.Element
  style?: { [key: string]: React.CSSProperties }
  setSearch: (search: IKeyValue<string | number>[]) => void
  customKeyMapping?: { [key: string]: string | number | boolean }
  showTimezone?: boolean
  showIcon?: boolean
  summaryKeys?: any
}

export interface ISearchFavourite {
  favList: IKeyValue<string | number>[]
  apiFilter: IApiFilter
  selectedFilter: IKeyValue<string | number>[]
  pageId: string
  selectFav: (id: IKeyValue<string | number>) => void
  deleteFavourite: (id: number) => void
  setSearch: (search: IKeyValue<string | number>[]) => void
  closest: (arr: any, searchValue: string) => IKeyValue<string>[]
  endDate: string | Date | undefined
  startDate: string | Date | undefined
  setSelectedFilter: (search: IKeyValue<string | number>[]) => void
  setShowAddFavModal: (item: boolean) => void
  customKeyMapping?: { [key: string]: string | number | boolean }
  showTimezone?: boolean
  showIcon?: boolean
  summaryKeys?: any
}

export interface IListFilters {
  pageId: string
  setSearch: (search: IKeyValue<string | number>[]) => void
  selectedFilter: IKeyValue<string | number>[]
  setSelectedFilter: (search: IKeyValue<string | number>[]) => void
}

export interface ISavedFavourites {
  favList: IKeyValue<string | number>[]
  deleteFavourite: (id: number) => void
  selectFav: (id: IKeyValue<string | number>) => void
}

export interface ISaveFavourite {
  setShowAddFavModal: (showSetFav: boolean) => void
}

export interface IAddFavourite {
  favName: string
  flagged: boolean
  setFlagged: (flagged: boolean) => void
  setFavName: (favName: string) => void
  saveFavorite: () => void
  selectedFilter: IKeyValue<string | number>[]
  showAddFavModal: boolean
  setShowAddFavModal: (showAddFavModal: boolean) => void
}

export interface IHeader extends RouteComponentProps {
  toggle?: IToggleContent[]
  showTimezone?: boolean
  endDate?: string | Date
  children?: ReactNode | ReactElement
  startDate?: string | Date
  lastUpdate?: string
  selectedKey?: string
  routesConfig?: Partial<IRouteConfig>[]
  searchData?: string
  setSearchData?: (search: string) => void
  rightTopCorner?: ReactNode | ReactElement
  setSelectedKey?: (search: string) => void
  showMobileMenu?: boolean
  setShowMobileMenu?: (showMobileMenu: boolean) => void
}

export interface IMapper extends RouteComponentProps {
  //TODO: Add On the Basis of requirement of module uses.
  maxRefreshCount?: number
  refreshInterval?: number
  routesConfig: Partial<IRouteConfig>[]
  baseUrl: string
  authToken: string
  pageConfigKey?: string
  type: string
  route?: any
  subType: string
  packageName?: string
  version: any
  versions: any
  showTimezone?: boolean
  timezone?: { timeZoneValue: string; localScanTime: boolean }
  timeFmt24Hr?: boolean
  selectedLanguage?: string
}

export interface ISummaryFilter {
  config: IApiFilter
  setSearch: (search: any) => void
  style?: React.CSSProperties
  hideNullKey?: boolean
}

export interface SummaryListItem {
  label: string
  value: number
  key: string[]
  description: string
}

interface ICoords {
  latitude: number
  longitude: number
}
interface ILocation {
  coords: ICoords
  timestamp: number
}
export interface ILocationPayload {
  success: boolean
  data: ILocation
}

export interface IDownloadToCSV {
  data: any[]
  fileName: string
  options?: json2csv.Options<any>
  type?: string
  extension?: string
}

export enum UserTypes {
  Developer = 'master',
  PA = 'pa',
  Admin = 'account_manager',
  'Non Admin' = 'child'
}
